import { render, staticRenderFns } from "./Wp_jd_share_model.vue?vue&type=template&id=5a1ded5b&scoped=true&"
import script from "./Wp_jd_share_model.vue?vue&type=script&lang=js&"
export * from "./Wp_jd_share_model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1ded5b",
  null
  
)

export default component.exports